import { TicketSearchPattern } from '../../enums/ticket-search-pattern';
import { ApiGetRequest } from './api-get-request';
import { ApiParameters } from './api-parameters';

export class TicketSearchRequest extends ApiGetRequest
{
    public query: number;
    public pattern: TicketSearchPattern;

    public constructor(query: string, lotteryClassId: number, pattern: TicketSearchPattern, webapiBasepath: string)
    {
        const parameters = new ApiParameters()
            .addQueryParameter('query', query)
            .addQueryParameter('lotteryclassid', lotteryClassId)
            .addQueryParameter('searchpattern', pattern);

        super('ticketsearch', parameters, null, webapiBasepath);
    }
}
